import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../types/RootState.js";
import { initialState } from "./slice.js";

const selectDomain = (state: RootState) => state.useAffiliationErrors || initialState;

export const selectUseAffiliationErrors = (key: string) => createSelector([selectDomain], (state) => state[key] || initialState);
